
import { Entity } from '../base/entity';

export class Company  extends Entity {

  public static readonly TABLENAME = 'company';

  public static readonly ID = 'id';
  public static readonly COMPANY_NAME = 'company_name';
  public static readonly COMPANY_TYPE = 'company_type';
  public static readonly ADDRESS = 'address';
  public static readonly CITY = 'city';
  public static readonly CITY_ID = "city_id";
  public static readonly POSTAL_CODE = 'postal_code';
  public static readonly STATE_PROVINCE = 'state_province';
  public static readonly COUNTRY_ID = 'country_id';
  public static readonly TIN = 'tin';
  public static readonly ID_NUMBER = 'id_number';
  public static readonly INDUSTRY_CODE = 'industry_code';
  public static readonly INDUSTRY_CODE_DESC = 'industry_code_desc';
  public static readonly PHONE = 'phone';
  public static readonly FAX = 'fax';
  public static readonly EMAIL = 'email';
  public static readonly WEBSITE = 'website';
  public static readonly COMMENT = 'comment';
  public static readonly REGISTER_NUMBER = "register_number";
  public static readonly PIB = "pib";
  public static readonly JBKJS = "jbkjs";
  public static readonly PAK = "pak";
  public static readonly VAT = "vat";
  public static readonly MATICNI_BROJ = "maticni_broj";
  public static readonly SHORT_NAME = "short_name";
  public static readonly CREATED_AT = 'created_at';
  public static readonly UPDATED_AT = 'updated_at';
  public static readonly DELETED_AT = 'deleted_at';

  id:               string;
  companyName:      string;
  companyType:      number;
  address:          string;
  cityId:           number;
  postalCode:       string;
  stateProvince:    string;
  countryId:        number;
  tin:              string;
  idNumber:         string;
  industryCode:     string;
  industryCodeDesc: string;
  phone:            string;
  fax:              string;
  email:            string;
  website:          string;
  comment:          string;
  account_number:   string;
  registerNumber:   string;
  pib:              string;
  jbkjs:            string;
  pak:              string;
  vat:              boolean;
  maticniBroj:      string;
  shortName:        string;
  createdAt:        Date;
  updatedAt:        Date;
  deletedAt:        Date;
  cityName: String;
}
